import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { ClientLayoutComponent } from '@pg-app/core/containers/client-layout/client-layout.component';
import { LayoutComponent } from '@pg-app/core/containers/layout/layout.component';
import { NotFoundComponent } from '@pg-app/core/containers/not-found/not-found.component';
import { UnderconstructionComponent } from '@pg-app/auth/components/underconstruction/underconstruction.component';
import { EmailConfirmationErrorComponent } from '@pg-app/common/email-confirmation-error/email-confirmation-error.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'client',
    component: ClientLayoutComponent,
    loadChildren: () => import('./client/client.module').then(m => m.ClientModule)
  },
  {
    path: 'partner',
    component: LayoutComponent,
    loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule)
  },
  {
    path: 'underconstruction',
    component: UnderconstructionComponent,
    children: [
      {
        path: '**',
        component: UnderconstructionComponent
      }
    ]
  },
  {
    path: 'link-expired/:email',
    component: EmailConfirmationErrorComponent,
  },
  {
    path: '',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: '/auth/login'
      },
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  },

  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '**',
        component: NotFoundComponent
      }
    ]
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
